export default __webpack_public_path__ + "static/media/30.ac2dafb4.jpeg";